import React from 'react'

const BasicText = ({ text,ref, ...props }) => {
    return (
        <p { ...props } ref={ref}>{text}</p>
    )
}

export default BasicText